import { apiTypeHelper } from '@/base/network'

export const GET_MY_PROFILE = apiTypeHelper('GET_MY_PROFILE')
export const GET_USER_PROFILE = apiTypeHelper('GET_USER_PROFILE')
export const UPDATE_USER_PROFILE = apiTypeHelper('UPDATE_USER_PROFILE')